import { Link } from "react-router-dom";

export function PrivacyPage() {
	return (
		<div className="wi-editorial-prose space-y-10 pb-24">
			<header className="space-y-4">
				<p className="font-geist text-wi-text/50 text-xs uppercase tracking-[0.16em]">Privacy</p>
				<h1 className="font-newsreader text-wi-text text-[2rem] leading-[1.1] tracking-tight sm:text-[2.65rem]">
					What we collect, what we keep, and what comes next
				</h1>
				<p className="font-geist text-[0.9rem] leading-relaxed text-wi-text/75 sm:text-[0.95rem]">
					This page is plain language for the public SPA. For technical posture, see{" "}
					<Link to="/trust/security" className="font-medium text-wi-gold underline-offset-2 hover:underline">
						Trust Center · Security
					</Link>{" "}
					and{" "}
					<Link to="/gears" className="font-medium text-wi-gold underline-offset-2 hover:underline">
						Gears
					</Link>
					.
				</p>
			</header>

			<section className="space-y-4">
				<h2 className="font-newsreader text-wi-text text-2xl tracking-tight sm:text-3xl">Data minimization</h2>
				<div className="space-y-3 font-geist text-[0.9rem] leading-relaxed text-wi-text/80 sm:text-[0.9375rem]">
					<p>
						We design around <strong className="text-wi-text">anonymous voting</strong> and{" "}
						<strong className="text-wi-text">no account wall for voters</strong>. There is no login or profile step for
						people who only hold the invitation link.
					</p>
					<p>
						Voters still receive a <strong className="text-wi-text">lightweight device id</strong> in the browser so we can
						enforce one ballot per device while a room is open — practical for a workshop, not a Sybil-resistant election
						system.
					</p>
				</div>
			</section>

			<section className="space-y-4 border-wi-text/10 border-t pt-10">
				<h2 className="font-newsreader text-wi-text text-2xl tracking-tight sm:text-3xl">What the Curator Link means</h2>
				<div className="space-y-3 font-geist text-[0.9rem] leading-relaxed text-wi-text/80 sm:text-[0.9375rem]">
					<p>
						Your <strong className="text-wi-text">Curator Link</strong> is the private URL that administers the poll. Anyone with that URL can
						administer the room. We store only a <strong className="text-wi-text">hash</strong> of the link credential in our database
						— not the raw secret in logs or support tooling.
					</p>
					<p>
						An optional <strong className="text-wi-text">HttpOnly cookie</strong> can remember the Curator session on the
					same device. If the Curator Link is lost and the cookie is gone, <strong className="text-wi-text">there is no password reset</strong>{" "}
					path — treat the link like a physical key.
					</p>
				</div>
			</section>

			<section className="space-y-4 border-wi-text/10 border-t pt-10">
				<h2 className="font-newsreader text-wi-text text-2xl tracking-tight sm:text-3xl">TTL and retention</h2>
				<div className="space-y-3 font-geist text-[0.9rem] leading-relaxed text-wi-text/80 sm:text-[0.9375rem]">
					<p>
						When a Curator launches a poll, they pick a <strong className="text-wi-text">time limit</strong> from preset
						windows (for example 2h, 4h, 24h, or 48h). That <strong className="text-wi-text">expiresAt</strong> travels
						with the room.
					</p>
					<p>
						<strong className="text-wi-text">After expiry</strong>, the Worker checks storage first: if the room was
						finalized, visitors can see <strong className="text-wi-text">read-only results</strong>; otherwise they see a
						calm expired state — <strong className="text-wi-text">no fabricated scores</strong>.
					</p>
				</div>
			</section>

			<section className="space-y-4 border-wi-text/10 border-t pt-10">
				<h2 className="font-newsreader text-wi-text text-2xl tracking-tight sm:text-3xl">Today’s web vs integration telemetry</h2>
				<div className="rounded-xl border border-wi-gold/25 bg-wi-surface/70 p-5 shadow-wi-soft">
					<h3 className="font-newsreader text-wi-text text-lg tracking-tight">Today (worthyidea.net SPA)</h3>
					<p className="mt-2 font-geist text-[0.875rem] leading-relaxed text-wi-text/78">
						Ballots, room metadata, and checkpoints can live in <strong className="text-wi-text">D1 (SQLite)</strong> for the
						TTL window — that is real persistence, not “memory-only.” We still avoid tracking cookies for voters and treat
						question text as sensitive in observability paths.
					</p>
				</div>
				<div className="mt-4 rounded-xl border border-wi-text/10 bg-wi-bg/80 p-5">
					<h3 className="font-newsreader text-wi-text text-lg tracking-tight">Planned (roadmap integrations)</h3>
					<p className="mt-2 font-geist text-[0.875rem] leading-relaxed text-wi-text/78">
						Longer-term docs describe <strong className="text-wi-text">host-native delivery</strong> (Slack, Teams, ticket
						systems) and <strong className="text-wi-text">organizational telemetry</strong> that reports delivery health,
						not ballot prose. Those behaviors are <strong className="text-wi-text">not global claims</strong> for the current
						public web stack — when they ship, this page and{" "}
						<Link to="/security" className="font-medium text-wi-gold underline-offset-2 hover:underline">
							Security
						</Link>{" "}
						will move from “planned” to “live.”
					</p>
				</div>
			</section>

			<section className="space-y-3 border-wi-text/10 border-t pt-10">
				<h2 className="font-newsreader text-wi-text text-2xl tracking-tight sm:text-3xl">Contact</h2>
				<p className="font-geist text-[0.9rem] leading-relaxed text-wi-text/75 sm:text-[0.9375rem]">
					For privacy questions, email{" "}
					<a href="mailto:privacy@worthyidea.net" className="font-medium text-wi-gold underline-offset-2 hover:underline">
						privacy@worthyidea.net
					</a>
					.
				</p>
			</section>

			<p className="font-geist text-sm text-wi-text/60">
				See also{" "}
				<Link to="/about" className="font-medium text-wi-gold underline-offset-2 hover:underline">
					About
				</Link>
				.
			</p>
		</div>
	);
}
